import $ from "jquery";


const _window          = $(window);
const _body            = $('body');

export const initMenu = function() {

   if (_window.width()<768) {
      $(".has-dropdown .menu__link").on('click',(function(e){
         e.preventDefault();
         if ($(this).parent().hasClass("active")) {
            $(this).parent().removeClass("active");
         } else {
            $(".has-dropdown").parent().removeClass("active");
            $(this).parent().addClass("active");
         }
      }));
  }

  

   



   


  $("#menu-button").on('click',(function(e){
     e.preventDefault();
      if (_body.hasClass('show-menu')){
         _body.removeClass("show-menu");
      } else {
         _body.addClass("show-menu");
      }
  }));

};